import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import ImageWithLoader2 from './components/ImageWithLoader2'; 
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function FamilyRequests() {
  
  const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();
  
  const queryClient = useQueryClient();

  const [tab, setTab] = useState("pending"); 
  const [selected, setSelected] = useState(null);

  const [selectedMember, setSelectedMember] = useState(null);
  
    const [searchModalOpen, setSearchModalOpen] = useState(false);

  const { data: members, isLoading, isError } = useQuery({
    queryKey: ['requestMembers'],
    queryFn: () => 
      axios.get(`${API_URL}/family-members-request-api`, { withCredentials: true })
        .then((response) => response.data),
    staleTime: 0,  // Data is not considered fresh after the request is completed
    cacheTime: Infinity,  // Keep the data cached indefinitely
  });

  const pendingMembers = members?.filter(m => m.status === "pending") || [];
const approvedMembers = members?.filter(m => m.status === "approved") || [];
const deniedMembers = members?.filter(m => m.status === "denied") || [];

  //accept request

  const handleAcceptSubmit = async (user_id) => {
    try {
      const res = await axios.post(
        `${API_URL}/family-request-accept-api`,
        { user_id: user_id },
        { withCredentials: true }
      );
  
      if (res.data.Status === "Success") {
        toast.success("Request accepted. The member will receive notification to join tree.");
        
        setSearchModalOpen(false); // Close modal
        queryClient.invalidateQueries(['requestMembers']); // Refresh request list
      } else {
        toast.error("Failed to accept request.");
      }
    } catch (error) {
      console.error("Request failed:", error);
      toast.error("Something went wrong.");
    }
  };


  const handRejectSubmit = async (user_id) => {
    try {
      const res = await axios.post(
        `${API_URL}/family-request-reject-api`,
        { user_id: user_id },
        { withCredentials: true }
      );
  
      if (res.data.Status === "Success") {
        toast.success("Request rejected!");
        
        setSearchModalOpen(false); // Close modal
        queryClient.invalidateQueries(['requestMembers']); // Refresh request list
      } else {
        toast.error("Failed to accept request.");
      }
    } catch (error) {
      console.error("Request failed:", error);
      toast.error("Something went wrong.");
    }
  };

  return (
    <div className='scrollPageContainer theme-light'>
      <div className='main-wrapper'>
        {isSidebarVisible && <Sidebar />}
        <Header toggleSidebar={toggleSidebar} />
        <Sidebar show={showSidebar} toggle={toggleSidebar} />
        <Footerbar toggleSidebar={toggleSidebar} />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>
          <div className="card border-0 shadow-sm rounded-4 mb-3 overflow-hidden">

          <div className="row">
          <div className="col-md-12">

          <div className="px-4 py-3 fr-bs-gradient-success">
                <div className="d-flex align-items-start gap-3">
                  <div className="d-inline-grid place-items-center rounded-3 p-2 bg-success-subtle text-success">
                    <i className="bi bi-person-badge fs-5" />
                  </div>
                  <div className="flex-grow-1">
                    <div className="d-flex flex-wrap align-items-baseline justify-content-between gap-2">
                      <h5 className="mb-0 fw-bold">Member requests</h5>
                    
                      <div className="small text-black-50">
                        <i className="bi bi-info-circle me-1"></i>
                        Review join requests, verify relation, approve or deny.
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div className="px-3 pt-2 pb-2">
                <div className="row g-2">
                  <StatCard
                    className="stat-btn"
                    active={tab === "pending"}
                    color="warning"
                    icon="bi-clock"
                    label="Pending"
                    value={pendingMembers.length}
                    onClick={() => setTab("pending")}
                  />
                  <StatCard
                    className="stat-btn"
                    active={tab === "approved"}
                    color="success"
                    icon="bi-check-circle"
                    label="Approved"
                    value={approvedMembers.length}
                    onClick={() => setTab("approved")}
                  />
                  <StatCard
                    className="stat-btn"
                    active={tab === "denied"}
                    color="danger"
                    icon="bi-x-circle"
                    label="Denied"
                    value={deniedMembers.length}
                    onClick={() => setTab("denied")}
                  />
                  <StatCard
                    className="stat-btn"
                    active={tab === "all"}
                    color="success"
                    icon="bi-person-plus"
                    label="All"
                    value={pendingMembers.length + approvedMembers.length + deniedMembers.length}
                    onClick={() => setTab("all")}
                  />
                </div>
              </div>



              <div className="mt-3">

  {tab === "pending" && (
    <div>
       
       {isLoading ? (
      <SkeletonList />
    ) : pendingMembers.length === 0 ? (
        
      <EmptyState
      title="No new requests"
      subtitle="You don’t have any member requests at the moment."
    />
        
      ) : (

        <div className="list-group list-group-flush">
        {pendingMembers.map(members => (

<div key={members.id} className="card list-group-item" style={{background: '#EBF4ED'}}>

            <div className="row">
                <div className="col-6 col-md-6 d-flex flex-column align-items-center">
                  
                <ImageWithLoader2
                  src={`${API_URL}/images/${members.profile_image}`}
                  placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                  fadeDuration={800}
                  blurAmount={15} 
                  alt={members.name}
                  className="img-fluid rounded-circle "
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }} />
                              
                  
                </div>
          
                <div className="col-6 col-md-6">
          
                  <p style={{ marginTop: '1%' }}>
                    <label className="h6 text-uppercase" style={{ fontFamily: 'Helvetica, serif', fontWeight: '600', color: '#000' }}>
                      {members.n_prefix} {members.name} {members.last_name} {members.surname}
                    </label>
                  </p>
                  <p>{members.phone_number}</p>
                  <p>{members.email}</p>
                  
                  <button type="button" className="btn-sm"
                      style={{ border: '1px solid #75B437', background: 'transparent', color: '#000', }}
                      onClick={() => {
                        setSelectedMember(members);      // Set member data
                        setSearchModalOpen(true);       // Open the modal
                      }}
                    >
                      More Info
                    </button>
                  
                </div>
              </div>
            
           
            
          </div>
        ))}
        </div>
      )}

    </div>
  )}

  {tab === "approved" && (
    <div>
       
      {approvedMembers.length === 0 ? (
        
        <EmptyState
      title="No approved requests "
      subtitle="You don’t have any member approved at the moment."
    />
        
      ) : (
       <div className="list-group list-group-flush">
        {approvedMembers.map(members => (
          
          <div key={members.id} className="card list-group-item" style={{background: '#EBF4ED'}}>

<div className="row">
                <div className="col-6 col-md-6 d-flex flex-column align-items-center">
                  
                <ImageWithLoader2
                  src={`${API_URL}/images/${members.profile_image}`}
                  placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                  fadeDuration={800}
                  blurAmount={15} 
                  alt={members.name}
                  className="img-fluid rounded-circle "
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }} />
                              
                  
                </div>
          
                <div className="col-6 col-md-6">
                  
          
                  <p style={{ marginTop: '1%' }}>
                    <label className="h6 text-uppercase" style={{ fontFamily: 'Helvetica, serif', fontWeight: '600', color: '#000' }}>
                      {members.n_prefix} {members.name} {members.last_name} {members.surname}
                    </label>
                  </p>
                  <p>{members.phone_number}</p>
                  <p>{members.email}</p>
                  
                 
                  
                </div>
              </div>
            
           
            
          </div>

        ))}
        </div>
      )}
    </div>
  )}

  {tab === "denied" && (
    <div>
      
      {deniedMembers.length === 0 ? (
        <EmptyState
        title="No denied requests "
        subtitle="You don’t have any member denied at the moment."
      />
      ) : (
       <div className="list-group list-group-flush">
        {deniedMembers.map(members => (

<div key={members.id} className="card list-group-item" style={{background: '#EBF4ED'}}>

<div className="row">
                <div className="col-6 col-md-6 d-flex flex-column align-items-center">
                  
                <ImageWithLoader2
                  src={`${API_URL}/images/${members.profile_image}`}
                  placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                  fadeDuration={800}
                  blurAmount={15} 
                  alt={members.name}
                  className="img-fluid rounded-circle "
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }} />
                              
                  
                </div>
          
                <div className="col-6 col-md-6">
                  
          
                  <p style={{ marginTop: '1%' }}>
                    <label className="h6 text-uppercase" style={{ fontFamily: 'Helvetica, serif', fontWeight: '600', color: '#000' }}>
                      {members.n_prefix} {members.name} {members.last_name} {members.surname}
                    </label>
                  </p>
                  <p>{members.phone_number}</p>
                  <p>{members.email}</p>
                  
                  
                  
                </div>
              </div>
            


          
        </div>


        ))}
        </div>
      )}
    </div>
  )}

  {tab === "all" && (
    <div className="list-group list-group-flush">
   
      {members?.map(members => (

<div key={members.id} className="card list-group-item" style={{background: '#EBF4ED'}}>

        <div className="row ">
                <div className="col-6 col-md-6 d-flex flex-column align-items-center">
                  
                <ImageWithLoader2
                  src={`${API_URL}/images/${members.profile_image}`}
                  placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                  fadeDuration={800}
                  blurAmount={15} 
                  alt={members.name}
                  className="img-fluid rounded-circle "
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }} />
                              
                  
                </div>
          
                <div className="col-6 col-md-6">
                  
          
                  <p style={{ marginTop: '1%' }}>
                    <label className="h6 text-uppercase" style={{ fontFamily: 'Helvetica, serif', fontWeight: '600', color: '#000' }}>
                      {members.n_prefix} {members.name} {members.last_name} {members.surname}
                    </label>
                  </p>
                  <p>{members.phone_number}</p>
                  <p>{members.email}</p>
                  
                  
                  
                </div>
              </div>
            




</div>

      ))}
    </div>
  )}

</div>



  <ReactModal isOpen={searchModalOpen} onRequestClose={() => setSearchModalOpen(false)} 
      className="Modal" overlayClassName="Overlay">
      
      <div className="modal-header" style={{background: '#EBF4ED', height: '40px', }}>

      
        <h5 className="modal-title" >
        {selectedMember && (
        <p class="mb-0 text-uppercase">
                  {selectedMember.n_prefix}{' '}{selectedMember.name}{' '}
                  {selectedMember.last_name} {selectedMember.surname}
                  </p>
                   )}
                   
        </h5>
        
        <button type="button" className="btn-close modalCloseButton" onClick={() => setSearchModalOpen(false)}></button>
      </div>
    
      <div className="modal-body">
        {selectedMember && (
          <div className="row">
            <div className="col-5 col-md-5">
            
            <button onClick={() => handRejectSubmit(selectedMember.id)} className="btn btn-outline-danger" > Reject Request</button>
            </div>
            <div className="col-2 col-md-2">

            </div>
            <div className="col-5 col-md-5">

            <button onClick={() => handleAcceptSubmit(selectedMember.id)} className="btn btn-outline-success">
  Accept Request
</button>

            </div>
          </div>
        )}
      </div>
    
     
    </ReactModal>



          </div>
          </div>



            <div className='row end-page-space'></div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



function StatCard({ active, color, icon, label, value, onClick, className = "" }) {
  return (
    <div className="col-6 col-lg-3">
      <button
        type="button"
        onClick={onClick}
        className={`w-100 text-start btn ${className} rounded-4 border-2 ${
          active ? `border-${color} bg-${color}-subtle shadow-sm` : "border-light bg-white"
        }`}
        style={{ cursor: "pointer" }}
      >
        <div className="d-flex align-items-center justify-content-between mb-1">
          <i className={`bi ${icon} ${active ? `text-${color}` : "text-secondary"}`} />
          <span className={`fs-4 fw-bold ${active ? `text-${color}` : "text-dark"}`}>{value}</span>
        </div>
        <div className={`${active ? `text-${color}` : "text-secondary"} small fw-medium`}>{label}</div>
      </button>
    </div>
  );
}

function Avatar({ src, alt, size = 48 }) {
  return (
    <div
      className="rounded-circle overflow-hidden bg-light border flex-shrink-0"
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={alt} className="w-100 h-100" style={{ objectFit: "cover" }} />
      ) : (
        <div className="w-100 h-100 d-grid place-items-center text-secondary">
          <i className="bi bi-person" />
        </div>
      )}
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div className="col-md-6">
      <div className="small text-uppercase text-secondary fw-medium">{label}</div>
      <div className="fw-semibold">{value || <span className="text-secondary">—</span>}</div>
    </div>
  );
}

function EmptyState({ title = "No requests found", subtitle = "Try again later." }) {
  return (
    <div className="p-5 text-center">
      <div className="d-inline-grid place-items-center rounded-4 mb-3 p-3 bg-success-subtle text-success fs-3">
        <i className="bi bi-inbox" />
      </div>
      <h6 className="fw-bold mb-1">{title}</h6>
      <p className="text-secondary mb-0">{subtitle}</p>
    </div>
  );
}

function SkeletonList() {
  return (
   <div className="list-group list-group-flush">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="list-group-item p-3">
          <div className="d-flex align-items-start gap-3">
            <div className="rounded-circle bg-body-secondary placeholder col-1" style={{ width: 44, height: 44 }}></div>
            <div className="flex-grow-1">
              <div className="placeholder-glow mb-2">
                <span className="placeholder col-6"></span>
              </div>
              <div className="placeholder-glow mb-2">
                <span className="placeholder col-3"></span>
              </div>
              <div className="placeholder-glow">
                <span className="placeholder col-9"></span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return new Intl.DateTimeFormat([], {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}


export default FamilyRequests;
